<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <b-row>
      <b-col md="8">
        <b-form-group :class="{'error-input' : $v.data_master.nama_siswa.$error}">
          <label> Nama Lengkap </label>
          <j-input
            v-model="$v.data_master.nama_siswa.$model"
            placeholder="Nama Lengkap"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nis.$error}">
          <label> NIS </label>
          <j-input
            v-model="$v.data_master.nis.$model"
            placeholder="NIS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nisn.$error}">
          <label> NISN </label>
          <j-input
            v-model="$v.data_master.nisn.$model"
            placeholder="NISN"/>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.data_master.foto_siswa.$error}">
          <label> Photo </label><br>
          <j-singleupload
            v-model="$v.data_master.foto_siswa.$model"
            :accepted-file-type="['jpg', 'png', 'jpeg']"
            :api-token="token"
            :url-upload="url_upload"
            @url="getUrl"/>
          <label>
            Please choose file with supported format file jpg, png, jpeg.
          </label>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
          <label> Tempat Lahir </label>
          <j-input
            v-model="$v.data_master.tempat_lahir.$model"
            placeholder="Tempat Lahir"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
          <label> Tanggal Lahir </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_lahir.$model"
            placeholder="Tanggal Lahir"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
          <label> Jenis Kelamin </label>
          <b-form-radio-group
            v-model="$v.data_master.jenis_kelamin.$model"
            :options="list_jenis_kelamin"
            :stacked="true"
            :disabled="false"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.agama.$error}">
          <label> Agama </label>
          <j-single-select
            v-model="$v.data_master.agama.$model"
            :options="list_agama"
            placeholder="Pilih Agama"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status_siswa.$error}">
          <label> Status Dalam Keluarga </label>
          <j-input
            v-model="$v.data_master.status_siswa.$model"
            placeholder="Status Dalam Keluarga"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.anak_ke.$error}">
          <label> Anak Ke </label>
          <j-input
            v-model="$v.data_master.anak_ke.$model"
            placeholder="Anak Ke"
            type="number"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_siswa.$error}">
          <label> Alamat Siswa </label>
          <j-textarea
            v-model="$v.data_master.alamat_siswa.$model"
            placeholder="Alamat Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_telepon.$error}">
          <label> Nomor Telepon Siswa </label>
          <j-input
            v-model="$v.data_master.no_telepon.$model"
            placeholder="Nomor Telepon Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.sekolah_asal.$error}">
          <label> Sekolah Asal </label>
          <j-input
            v-model="$v.data_master.sekolah_asal.$model"
            placeholder="Sekolah Asal"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.diterima_dikelas.$error}">
          <label> Diterima Di Kelas </label>
          <j-input
            v-model="$v.data_master.diterima_dikelas.$model"
            placeholder="Diterima Di Kelas"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_diterima.$error}">
          <label> Tanggal Diterima </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_diterima.$model"
            placeholder="Tanggal Diterima"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ayah.$error}">
          <label> Nama Ayah Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ayah.$model"
            placeholder="Nama Ayah Kandung"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ibu.$error}">
          <label> Nama Ibu Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ibu.$model"
            placeholder="Nama Ibu Kandung"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_ortu.$error}">
          <label> Alamat Orang Tua </label>
          <j-textarea
            v-model="$v.data_master.alamat_ortu.$model"
            placeholder="Alamat Orang Tua"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_telepon_rumah.$error}">
          <label> Nomor Telepon Rumah </label>
          <j-input
            v-model="$v.data_master.no_telepon_rumah.$model"
            placeholder="Nomor Telepon Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_ayah.$error}">
          <label> Pekerjaan Ayah </label>
          <j-input
            v-model="$v.data_master.pekerjaan_ayah.$model"
            placeholder="Pekerjaan Ayah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_ibu.$error}">
          <label> Pekerjaan Ibu </label>
          <j-input
            v-model="$v.data_master.pekerjaan_ibu.$model"
            placeholder="Pekerjaan Ibu"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_wali.$error}">
          <label> Nama Wali Siswa </label>
          <j-input
            v-model="$v.data_master.nama_wali.$model"
            placeholder="Nama Wali Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_wali.$error}">
          <label> Alamat Wali </label>
          <j-textarea
            v-model="$v.data_master.alamat_wali.$model"
            placeholder="Alamat Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.notlp_wali.$error}">
          <label> Nomor Telepon Wali </label>
          <j-input
            v-model="$v.data_master.notlp_wali.$model"
            placeholder="Nomor Telepon Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_wali.$error}">
          <label> Pekerjaan Wali </label>
          <j-input
            v-model="$v.data_master.pekerjaan_wali.$model"
            placeholder="Pekerjaan Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nik_kitas.$error}">
          <label> NIK/No. KITAS </label>
          <j-input
            v-model="$v.data_master.nik_kitas.$model"
            placeholder="NIK/No. KITAS"
            type="number"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.warga_negara.$error}">
          <label> Kewarganegaraan </label>
          <j-input
            v-model="$v.data_master.warga_negara.$model"
            placeholder="Kewarganegaraan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.berkebutuhan_khusus.$error}">
          <label> Berkebutuhan Khusus </label>
          <j-input
            v-model="$v.data_master.berkebutuhan_khusus.$model"
            placeholder="Berkebutuhan Khusus"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rt.$error}">
          <label> RT </label>
          <j-input
            v-model="$v.data_master.rt.$model"
            placeholder="RT"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rw.$error}">
          <label> RW </label>
          <j-input
            v-model="$v.data_master.rw.$model"
            placeholder="RW"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.dusun.$error}">
          <label> Dusun </label>
          <j-input
            v-model="$v.data_master.dusun.$model"
            placeholder="Dusun"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.desa_kelurahan.$error}">
          <label> Kelurahan/Desa </label>
          <j-input
            v-model="$v.data_master.desa_kelurahan.$model"
            placeholder="Kelurahan/Desa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kecamatan.$error}">
          <label> Kecamatan </label>
          <j-input
            v-model="$v.data_master.kecamatan.$model"
            placeholder="Kecamatan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kodepos.$error}">
          <label> Kode POS </label>
          <j-input
            v-model="$v.data_master.kodepos.$model"
            placeholder="Kode POS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tempat_tinggal.$error}">
          <label> Tempat Tinggal </label>
          <j-single-select
            v-model="$v.data_master.tempat_tinggal.$model"
            :options="list_tempat_tinggal"
            placeholder="Pilih Tempat Tinggal"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.moda_transportasi.$error}">
          <label> Moda Transportasi </label>
          <j-single-select
            v-model="$v.data_master.moda_transportasi.$model"
            :options="list_moda_transportasi"
            placeholder="Pilih Moda Transportasi"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.penerima_kps.$error}">
          <label> Penerima KPS </label>
          <j-input
            v-model="$v.data_master.penerima_kps.$model"
            placeholder="Penerima KPS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_kps.$error}">
          <label> No KPS </label>
          <j-input
            v-model="$v.data_master.no_kps.$model"
            placeholder="No KPS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.layak_pip.$error}">
          <label> Layak PIP </label>
          <j-input
            v-model="$v.data_master.layak_pip.$model"
            placeholder="Layak PIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alasan_layak_pip.$error}">
          <label> Alasan Layak PIP </label>
          <j-single-select
            v-model="$v.data_master.alasan_layak_pip.$model"
            :options="list_alasan_layak_pip"
            placeholder="Pilih Alasan Layak PIP"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_kip.$error}">
          <label> No KIP </label>
          <j-input
            v-model="$v.data_master.no_kip.$model"
            placeholder="No KIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_tertera_di_kip.$error}">
          <label> Nama Tertera di KIP </label>
          <j-input
            v-model="$v.data_master.nama_tertera_di_kip.$model"
            placeholder="Nama Tertera di KIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_kks.$error}">
          <label> Nomor KKS </label>
          <j-input
            v-model="$v.data_master.no_kks.$model"
            placeholder="Nomor KKS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.bank.$error}">
          <label> Bank </label>
          <j-input
            v-model="$v.data_master.bank.$model"
            placeholder="Bank"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_akta_lahir.$error}">
          <label> Nomor Registrasi Akta Lahir </label>
          <j-input
            v-model="$v.data_master.no_akta_lahir.$model"
            placeholder="Nomor Registrasi Akta Lahir"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_rekening_bank.$error}">
          <label> No. Rekening Bank </label>
          <j-input
            v-model="$v.data_master.no_rekening_bank.$model"
            placeholder="No. Rekening Bank"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rekening_atas_nama.$error}">
          <label> Rekening Atas Nama </label>
          <j-input
            v-model="$v.data_master.rekening_atas_nama.$model"
            placeholder="Rekening Atas Nama"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.npsn_sekolah_asal.$error}">
          <label> NPSN Sekolah Asal </label>
          <j-input
            v-model="$v.data_master.npsn_sekolah_asal.$model"
            placeholder="NPSN Sekolah Asal"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="float-to-right m__t--20">
          <b-button
            class="btn blue m__r--5"
            @click="saveData">
            Save
          </b-button>
          <b-button
            class="btn gray"
            @click="$router.replace('/data-siswa')">
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  components: {
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Create Data',
      },

      data_master: {
        nis: '',
        nisn: '',
        nama_siswa: '',
        alamat_siswa: '',
        foto_siswa: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        jenis_kelamin: null,
        agama: null,
        warga_negara: '',
        anak_ke: 0,
        jml_sdr_kandung: 0,
        jml_sdr_tiri: 0,
        jml_sdr_angkat: 0,
        yatim_piatu: '',
        bahasa_harian: '',
        status_siswa: null,
        ket_status: '',
        post_date: null,
        nama_ayah: '',
        nama_ibu: '',
        alamat_ortu: '',
        notlp_ortu: '',
        nama_wali: '',
        alamat_wali: '',
        notlp_wali: '',
        pekerjaan_ayah: '',
        pekerjaan_ibu: '',
        pekerjaan_wali: '',
        tahunmasuk: '',
        sekolah_asal: '',
        diterima_dikelas: '',
        tanggal_diterima: null,
        nik_kitas: '',
        berkebutuhan_khusus: '',
        rt: '',
        rw: '',
        dusun: '',
        desa_kelurahan: '',
        kecamatan: '',
        kodepos: '',
        tempat_tinggal: null,
        moda_transportasi: null,
        penerima_kps: '',
        no_kps: '',
        layak_pip: '',
        alasan_layak_pip: null,
        no_kip: '',
        nama_tertera_di_kip: '',
        no_kks: '',
        bank: '',
        no_akta_lahir: '',
        no_rekening_bank: '',
        rekening_atas_nama: '',
        npsn_sekolah_asal: '',
        nik_ayah: '',
        tahun_lahir_ayah: '',
        pendidikan_ayah: '',
        penghasilan_ayah: '',
        kebutuhan_khusus_ayah: '',
        nik_ibu: '',
        tahun_lahir_ibu: '',
        pendidikan_ibu: '',
        penghasilan_ibu: '',
        kebutuhan_khusus_ibu: '',
        nik_wali: '',
        tahun_lahir_wali: '',
        pendidikan_wali: '',
        penghasilan_wali: '',
        no_telepon_rumah: '',
        no_telepon: '',
        email: '',
        berat_badan: '',
        tinggi_badan: '',
        jarak_ke_sekolah: '',
        jarak_dalam_km: '',
        waktu_jam: '',
        waktu_menit: '',
        jumlah_saudara_kandung: '',
      },
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      list_jenis_kelamin: [
        {
          value: 'Laki-Laki',
          text: 'Laki-Laki',
        },
        {
          value: 'Perempuan',
          text: 'Perempuan',
        },
      ],
      list_agama: [
        {
          id: 'Islam',
          name: 'Islam',
        },
        {
          id: 'Kristen/Protestan',
          name: 'Kristen/Protestan',
        },
        {
          id: 'Hindu',
          name: 'Hindu',
        },
        {
          id: 'Budha',
          name: 'Budha',
        },
        {
          id: 'Kong Hu Chu',
          name: 'Kong Hu Chu',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_tempat_tinggal: [
        {
          id: 'Bersama Orang Tua',
          name: 'Bersama Orang Tua',
        },
        {
          id: 'Wali',
          name: 'Wali',
        },
        {
          id: 'Kos',
          name: 'Kos',
        },
        {
          id: 'Asrama',
          name: 'Asrama',
        },
        {
          id: 'Panti Asuhan',
          name: 'Panti Asuhan',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_moda_transportasi: [
        {
          id: 'Jalan Kaki',
          name: 'Jalan Kaki',
        },
        {
          id: 'Kendaraan Pribadi',
          name: 'Kendaraan Pribadi',
        },
        {
          id: 'Kendaraan Umum',
          name: 'Kendaraan Umum',
        },
        {
          id: 'Jemputan Sekolah',
          name: 'Jemputan Sekolah',
        },
        {
          id: 'Kereta Api',
          name: 'Kereta Api',
        },
        {
          id: 'Ojek',
          name: 'Ojek',
        },
        {
          id: 'Andong/Bendi/Sado/Dokar/Delman/Beca',
          name: 'Andong/Bendi/Sado/Dokar/Delman/Beca',
        },
        {
          id: 'Perahu Penyebrangan/Rakit/Getek',
          name: 'Perahu Penyebrangan/Rakit/Getek',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_alasan_layak_pip: [
        {
          id: 'Pemegang PKH/KPS/KIP',
          name: 'Pemegang PKH/KPS/KIP',
        },
        {
          id: 'Penerima BSM 2014',
          name: 'Penerima BSM 2014',
        },
        {
          id: 'Yatim Piatu/Panti Asuhan/Panti Sosial',
          name: 'Yatim Piatu/Panti Asuhan/Panti Sosial',
        },
        {
          id: 'Dampak Bencana Alam',
          name: 'Dampak Bencana Alam',
        },
        {
          id: 'Pernah Drop Out',
          name: 'Pernah Drop Out',
        },
        {
          id: 'Siswa Miskin/Rentan Miskin',
          name: 'Siswa Miskin/Rentan Miskin',
        },
        {
          id: 'Daerah Konflik',
          name: 'Daerah Konflik',
        },
        {
          id: 'Keluarga Terpidana',
          name: 'Keluarga Terpidana',
        },
        {
          id: 'Kelainan Fisik',
          name: 'Kelainan Fisik',
        },
      ],
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreKesiswaan', ['createSiswa']),

    getUrl(data) {
      this.data_master.foto_siswa = data;
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const param = this.data_master;
        param.tanggal_lahir = param.tanggal_lahir ? this.$moment(param.tanggal_lahir).format('YYYY-MM-DD') : '';
        param.tanggal_diterima = param.tanggal_diterima ? this.$moment(param.tanggal_diterima).format('YYYY-MM-DD') : '';
        this.createSiswa(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.push('/data-siswa');
            }, 1500);
          }
        });
      }
    },
  },
  validations() {
    return {
      data_master: {
        nis: { required },
        nisn: { required },
        nama_siswa: { required },
        alamat_siswa: { required },
        foto_siswa: {},
        tempat_lahir: {},
        tanggal_lahir: {},
        jenis_kelamin: {},
        agama: {},
        warga_negara: {},
        anak_ke: {},
        jml_sdr_kandung: {},
        jml_sdr_tiri: {},
        jml_sdr_angkat: {},
        yatim_piatu: {},
        bahasa_harian: {},
        status_siswa: {},
        ket_status: {},
        post_date: {},
        nama_ayah: {},
        nama_ibu: {},
        alamat_ortu: {},
        notlp_ortu: {},
        nama_wali: {},
        alamat_wali: {},
        notlp_wali: {},
        pekerjaan_ayah: {},
        pekerjaan_ibu: {},
        pekerjaan_wali: {},
        tahunmasuk: {},
        sekolah_asal: {},
        diterima_dikelas: {},
        tanggal_diterima: {},
        nik_kitas: {},
        berkebutuhan_khusus: {},
        rt: {},
        rw: {},
        dusun: {},
        desa_kelurahan: {},
        kecamatan: {},
        kodepos: {},
        tempat_tinggal: {},
        moda_transportasi: {},
        penerima_kps: {},
        no_kps: {},
        layak_pip: {},
        alasan_layak_pip: {},
        no_kip: {},
        nama_tertera_di_kip: {},
        no_kks: {},
        bank: {},
        no_akta_lahir: {},
        no_rekening_bank: {},
        rekening_atas_nama: {},
        npsn_sekolah_asal: {},
        nik_ayah: {},
        tahun_lahir_ayah: {},
        pendidikan_ayah: {},
        penghasilan_ayah: {},
        kebutuhan_khusus_ayah: {},
        nik_ibu: {},
        tahun_lahir_ibu: {},
        pendidikan_ibu: {},
        penghasilan_ibu: {},
        kebutuhan_khusus_ibu: {},
        nik_wali: {},
        tahun_lahir_wali: {},
        pendidikan_wali: {},
        penghasilan_wali: {},
        no_telepon_rumah: {},
        no_telepon: {},
        email: {},
        berat_badan: {},
        tinggi_badan: {},
        jarak_ke_sekolah: {},
        jarak_dalam_km: {},
        waktu_jam: {},
        waktu_menit: {},
        jumlah_saudara_kandung: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/siswa/jSiswaCreate.vue